<template>
  <div class="dredge-vip-anchor">
    <div class="dredge-contain align direction">
      <img class="dredge-icon" src="../static/images/dredge-vip.png" alt="">
      <div class="dredge-tips">
        成为VIP会员，即可免费查看快手达人详细信息、直<br>
        播数据、带货数据及其他尊享服务
      </div>
    </div>
    <a href="/dredgeVip" class="open-now align jus">
      <div class="open-vip-button">立即开通</div>
    </a>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="less" scoped>
  .dredge-vip-anchor {
    padding-top: .6rem;
    .dredge-contain {
      height: 3.5rem;
      width: 100vw;
      padding-top: .8rem;
      text-align: center;
      background: rgba(255, 255, 255, 1);

      .dredge-icon {
        width: 2rem;
        height: 0.6rem;
        margin-bottom: 0.44rem;
      }

      .dredge-tips {
        font-size: .28rem;
        font-weight: 400;
        color: rgba(161, 174, 191, 1);
        line-height: .40rem;
        margin-bottom: .45rem;
      }

      .open-now {
        width: 3.00rem;
        height: 1.00rem;
        line-height: 1rem;
        color: #FFFFFF;
        font-size: .36rem;
        background: linear-gradient(180deg, rgba(255, 201, 0, 1) 0%, rgba(255, 153, 0, 1) 100%);
        border-radius: .08rem;
      }
    }
    .open-now {
      width: 100vw;
      height: 1.2rem;
      position: fixed;
      bottom: 0;
      left: 0;
      background: #fff;
      z-index: 100;
      .open-vip-button {
        width: 6.9rem;
        height: 0.8rem;
        border-radius: .4rem;
        text-align: center;
        line-height: 0.8rem;
        background: #FF9900;
        color: #fff;
        font-size: .3rem;
      }
    }
  }
</style>